"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Modal = _interopRequireDefault(require("@material-ui/core/Modal"));

var _Backdrop = _interopRequireDefault(require("@material-ui/core/Backdrop"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var buildModalStyles = function buildModalStyles(_ref) {
  var palette = _ref.theme.palette;
  return (0, _styledComponents.css)(["display:flex;align-items:center;justify-content:center;& .MuiBackdrop-root{background-color:", "CC;}"], palette.primary.dark);
};

var buildContainerStyles = function buildContainerStyles(_ref2) {
  var width = _ref2.width,
      typography = _ref2.theme.typography;
  return (0, _styledComponents.css)(["top:50%;left:50%;width:", ";margin:auto;outline:none;"], typography.pxToRem(width));
};

var CustomModal = /*#__PURE__*/(0, _styledComponents["default"])(_Modal["default"]).withConfig({
  displayName: "Modal__CustomModal"
})(["", ""], buildModalStyles);

var Container = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  displayName: "Modal__Container"
})(["", ""], buildContainerStyles);

var Modal = function Modal(_ref3) {
  var width = _ref3.width,
      children = _ref3.children,
      rest = _objectWithoutProperties(_ref3, ["width", "children"]);

  return _react["default"].createElement(CustomModal, _extends({}, rest, {
    BackdropComponent: _Backdrop["default"]
  }), _react["default"].createElement(Container, {
    width: width
  }, children));
};

Modal.defaultProps = {
  width: 448,
  open: false,
  onClose: function onClose() {}
};
Modal.propTypes = {
  width: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  open: _propTypes["default"].bool,
  onClose: _propTypes["default"].func
};
var _default = Modal;
exports["default"] = _default;